import axiosInstance from '@/utils/api.js'

var state = {
  sessions: []
}

var getters = {
  SESSIONS: (state) => {
    return state.sessions
  }
}

var mutations = {
  SET_SESSIONS: (state, payload) => {
    state.sessions = payload
  }
}

var actions = {
  GET_SESSIONS: async (context, payload) => {
    let result = await axiosInstance.get('/reports/sessions?accounting_period_id=0&account_id=0&start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_SESSIONS', result.data)
    }
  },
  CLEAR_SESSIONS: (context) => {
    context.commit('SET_SESSIONS', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/sessions.js